import * as SDLCMetadataConstants from "./sdlcMetadataConstants";
/* eslint import/no-named-as-default-member: 0 */
export function stringIsExploitPresence(testValue) {
    return SDLCMetadataConstants.exploitPresence.includes(testValue);
}
export function stringArrayIsExploitPresence(testValue) {
    let result = true;
    testValue.forEach((item) => (result =
        result &&
            SDLCMetadataConstants.exploitPresence.includes(item)));
    return result;
}
export function stringIsIssueEstimate(testValue) {
    return SDLCMetadataConstants.issueEstimate.includes(testValue);
}
export function stringIsReleaseStatus(testValue) {
    return SDLCMetadataConstants.releaseStatus.includes(testValue);
}
export function stringIsSoftwareGrade(testValue) {
    return SDLCMetadataConstants.softwareGrade.includes(testValue);
}
export function stringIsDependencyLinking(testValue) {
    return SDLCMetadataConstants.dependencyLinking.includes(testValue);
}
export function stringIsToolchainType(testValue) {
    return SDLCMetadataConstants.toolchainType.includes(testValue);
}
export function stringIsSoftwareType(testValue) {
    return SDLCMetadataConstants.softwareType.includes(testValue);
}
export function stringIsFormatCategory(testValue) {
    return SDLCMetadataConstants.formatCategory.includes(testValue);
}
export function stringIsInstallType(testValue) {
    return SDLCMetadataConstants.install.includes(testValue);
}
export function stringIsSoftwareScenario(testValue) {
    return SDLCMetadataConstants.scenario.includes(testValue);
}
export function stringIsCommunityType(testValue) {
    return SDLCMetadataConstants.community.includes(testValue);
}
export function stringIsIdentityVerification(testValue) {
    return SDLCMetadataConstants.identityVerification.includes(testValue);
}
export function stringIsLanguageDetector(testValue) {
    return SDLCMetadataConstants.languageDetector.includes(testValue);
}
export function stringIsStoryArgument(testValue) {
    return SDLCMetadataConstants.storyArgument.includes(testValue);
}
export function stringIsClassification(testValue) {
    return SDLCMetadataConstants.classification.includes(testValue);
}
export function stringIsDiffChange(testValue) {
    return SDLCMetadataConstants.diffChange.includes(testValue);
}
export function stringIsDiffObject(testValue) {
    return SDLCMetadataConstants.diffObject.includes(testValue);
}
export function stringIsDiffReproCheck(testValue) {
    return SDLCMetadataConstants.diffReproCheck.includes(testValue);
}
export function stringIsAssessmentStatus(testValue) {
    return SDLCMetadataConstants.assessmentStatus.includes(testValue);
}
export function stringIsAssessmentType(testValue) {
    return SDLCMetadataConstants.assessment.includes(testValue);
}
export function stringIsNetworkFlow(testValue) {
    return SDLCMetadataConstants.networkFlow.includes(testValue);
}
export function stringIsNetworkService(testValue) {
    return SDLCMetadataConstants.networkService.includes(testValue);
}
export function stringIsSecretLiveness(testValue) {
    return SDLCMetadataConstants.secretLiveness.includes(testValue);
}
export function stringIsBehaviorPrevalence(testValue) {
    return SDLCMetadataConstants.prevalence.includes(testValue);
}
export function stringIsMlRelevance(testValue) {
    return SDLCMetadataConstants.relevance.includes(testValue);
}
export function stringIsMlParamType(testValue) {
    return SDLCMetadataConstants.mlParamType.includes(testValue);
}
export function stringIsMlApproach(testValue) {
    return SDLCMetadataConstants.mlApproach.includes(testValue);
}
export function stringIsLicenseFamily(testValue) {
    return SDLCMetadataConstants.licenseFamily.includes(testValue);
}
export function stringIsCryptoMaterial(testValue) {
    return SDLCMetadataConstants.cryptoMaterial.includes(testValue);
}
export function stringIsCryptoFunction(testValue) {
    return SDLCMetadataConstants.cryptoFunction.includes(testValue);
}
export function stringIsCryptoSource(testValue) {
    return SDLCMetadataConstants.cryptoSource.includes(testValue);
}
export function stringIsCryptoOperation(testValue) {
    return SDLCMetadataConstants.cryptoOperation.includes(testValue);
}
export function stringIsCryptoPrimitive(testValue) {
    return SDLCMetadataConstants.cryptoPrimitive.includes(testValue);
}
export function stringIsActionType(testValue) {
    return SDLCMetadataConstants.actionType.includes(testValue);
}
export function stringIsEventType(testValue) {
    return SDLCMetadataConstants.eventType.includes(testValue);
}
//# sourceMappingURL=sdlcMetadataTypeGuards.js.map